<template>
  <div class="profile-main">
    <div class="info-title">
      <p class="title-main">Welcome!</p>
      <p class="title-subtitle">Fill in brand information and detailed information</p>
    </div>
    <div class="info-main">
      <el-form :model="profileForm" ref="profileForm" :rules="rules" v-loading="loading">
        <!-- Business -->
        <el-form-item
          label="Brand Name"
          prop="brandName"
        >
          <el-input
            maxlength="50"
            show-word-limit
            v-model="profileForm.brandName"
            placeholder="Brand Name"
          />
        </el-form-item>

        <!-- Primary Category -->
        <el-form-item
          label="Primary Category"
          prop="primaryCategory"
        >
          <el-select v-model="profileForm.primaryCategory" multiple :multiple-limit="3" filterable placeholder="Primary Category">
            <el-option
              v-for="item in primaryCategoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- Do you have a factory? -->
        <el-form-item
          label="Do you have a factory?"
          prop="isHaveFactory"
        >
          <el-radio-group v-model="profileForm.isHaveFactory">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- Current city -->
        <el-form-item
          label="Current city"
          prop="currentCity"
        >
          <el-input
            maxlength="50"
            show-word-limit
            v-model="profileForm.currentCity"
            placeholder="Current city"
          />
        </el-form-item>

        <!-- Website -->
        <el-form-item
          label="Website"
          prop="website"
        >
          <el-input
            v-model="profileForm.website"
            placeholder="Independent website/Amazon/other website URL"
          />
        </el-form-item>

        <!-- independent stores -->
        <el-form-item
          label="How many independent stores do you work with?"
          prop="independentStores"
        >
          <el-select v-model="profileForm.independentStores"  placeholder="How many independent stores do you work with?">
            <el-option
              v-for="item in independentStoreoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- wholesale products -->
        <el-form-item
          label="How many wholesale products do you sell?"
          prop="wholesaleProducts"
        >
          <el-select v-model="profileForm.wholesaleProducts"  placeholder="How many wholesale products do you sell?">
            <el-option
              v-for="item in wholesaleProductsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- independent stores -->
        <el-form-item
          label="How did you hear about us?"
          prop="aboutUs"
        >
          <el-select v-model="profileForm.aboutUs"  placeholder="How did you hear about us?">
            <el-option
              v-for="item in aboutUsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="action" @click="confirm('profileForm')">Next</div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage.js'
import { postAction } from '../../../api/manage'
export default {
  data() {
    return {
      profileForm: {},
      rules: {
        brandName: [
          { required: true, trigger: ['change', 'blur'], validator: this.checkBrandName }
        ],
        primaryCategory: [
          { required: true, message: 'Please select the Primary Category', trigger: ['blur', 'change'] }
        ],
        isHaveFactory: [
          { required: true, message: 'Please choose you have a factory', trigger: ['change', 'blur'] }
        ],
        currentCity: [
          { required: true, trigger: ['change', 'blur'], validator: this.checkCurrentCityName }
        ],
        independentStores: [
          { required: true, message: 'Please select the independent stores', trigger: ['blur', 'change'] }
        ],
        wholesaleProducts: [
          { required: true, message: 'Please select the wholesale products', trigger: ['blur', 'change'] }
        ],
        aboutUs: [
          { required: true, message: 'Please select the about us', trigger: ['blur', 'change'] }
        ]
      },
      loading: false,
      primaryCategoryOptions: [],
      independentStoreoptions: [
        {value: 'I am new to wholesale'},
        {value: '1-3'},
        {value: '3-5'},
        {value: '5+'}
      ],
      wholesaleProductsOptions: [
        {value: 'I do not currently sell wholesale products'},
        {value: '1-10'},
        {value: '11-25'},
        {value: '26-50'},
        {value: '51+'}
      ],
      aboutUsOptions: [
        {value: 'Social Media'},
        {value: 'Another Brand'},
        {value: 'A Retailer'},
        {value: 'A ShopVidi employee'},
        {value: 'Other'}
      ]
    }
  },
  created() {
    this.getCategory()
  },
  methods: {
    checkBrandName(rule, value, callback) {
      if (value) {
        value = value.trim()
        if (value === '') {
          this.profileForm.brandName = ''
          callback(new Error('Please enter in Brand Name'))
        } else {
          callback()
        }
      } else {
        callback(new Error('Please enter in Brand Name'))
      }
    },
    checkCurrentCityName(rule, value, callback) {
      if (value) {
        value = value.trim()
        if (value === '') {
          this.profileForm.currentCity = ''
          callback(new Error('Please enter the Current city'))
        } else {
          callback()
        }
      } else {
        callback(new Error('Please enter the Current city'))
      }
    },
    getCategory() {
      getAction('/sys/category/rootList?code=supplier_type').then(response => {
        if (response.success) {
          if (response.result && response.result.records) {
            for (var index = 0; index < response.result.records.length; index++) {
              const primaryCategoryObject = {}
              primaryCategoryObject.value = response.result.records[index].name
              this.primaryCategoryOptions.push(primaryCategoryObject)
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    confirm(type) {
      // 校验
      this.$refs[type].validate(async (valid) => {
        if (valid) {
          // 组装数据请求后台
          const params = {
            userKey: JSON.parse(localStorage.getItem('pro__userInfo')).value.id,
            businessName: this.profileForm.brandName,
            supplierTypeList: this.profileForm.primaryCategory,
            hasFactory: this.profileForm.isHaveFactory,
            city: this.profileForm.currentCity,
            websiteUrl: this.profileForm.website,
            independentStore: this.profileForm.independentStores,
            wholesaleProduct: this.profileForm.wholesaleProducts,
            hearAboutUs: this.profileForm.aboutUs
          }
          postAction('/register/supplier/replenish', params).then(response => {
            if (response.success) {
              this.$emit('gotoReview')
            } else {
              this.$message.warning(response.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.info-title {
  width: 100%;
  text-align: center;
  .title-main {
    font-size: 24px;
    line-height: 60px;
    margin-top: 58px;
    color: #262b2f;
  }
  .title-subtitle {
    font-size: 14px;
    margin-bottom: 40px;
    color: #262b2f;
  }
}
.profile-main{
  width: 25%;
}
.action{
  width: 50%;
  margin: 0 auto;
  height: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #262B2F;
  color: #FFFFFF;
  margin-top: 20px;
}
/deep/ .el-select{
  width: 100%;
}
/deep/ .el-radio-group{
  width: 100%;
}
/deep/ .el-form-item__label{
  display: flex;
  flex-direction: row-reverse;
}
/deep/ .el-form-item__label::before{
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/brand-review/profile.vue